import { render, staticRenderFns } from "./view.vue?vue&type=template&id=21858a54&scoped=true"
var script = {}
import style0 from "./view.vue?vue&type=style&index=0&id=21858a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21858a54",
  null
  
)

export default component.exports